module.exports = __webpack_public_path__ + "static/media/ic_apple_black.8eaa545f.svg";